import { render, staticRenderFns } from "./LayoutHeader.vue?vue&type=template&id=ef02faa0&scoped=true&"
import script from "./LayoutHeader.vue?vue&type=script&lang=ts&"
export * from "./LayoutHeader.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutHeader.vue?vue&type=style&index=0&id=ef02faa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef02faa0",
  null
  
)

export default component.exports